/* eslint-disable react/jsx-no-constructed-context-values */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable camelcase */
import React, { useContext, createContext, useState } from 'react';
import { getStorege, saveStorege } from '../../helpers/db_storage';
import { api } from '../../services';
import { useLoadingContext } from '../use-loading';
import { useSignInContext } from '../use-signin';

interface IparamLogin {
  user_name: string;
  user_password: string;
}

interface iResult {
  status: number;
  data: {
    mensagem: any;
    retorno: any;
    token: string;
    length: any;
    codigo: any;
  };
}

interface IUser {
  idUsuario: number;
  dsNome: string;
  dsSenha: string;
  dsEmail: string;
}

type IData = {
  message?: {
    user?: IUser | any;
  };
  typeValidation?: string;
  codeValidation?: any;
  user?: IUser | any;
  return?: any;
  signedLoading?: boolean;
  msgError?: string;
  statusCode?: number;
};

type IUserUpdateContext = {
  data: IData;
  signed: boolean;
  progress: number;
  userUpdate(paramLogin: IparamLogin): Promise<void>;
  setDataUpdateStorage(params: string): Promise<void>;
  setEmailStorage(email: string): Promise<void>;
  setValidation(type: string): Promise<void>;
  cleanData(): Promise<void>;
  setPhoneStorage(phone: any, type: string): Promise<void>;
};
const SignInContext = createContext<Partial<IUserUpdateContext>>({});

export const UserUpdateProvider = ({ children }: any) => {
  const { createloading } = useLoadingContext();
  const { getDataUser } = useSignInContext();

  const [data, setData] = useState<IData>({
    signedLoading: false,
    message: {
      user: null,
    },
    typeValidation: '',
    codeValidation: '',
    return: '',
    user: null,
    msgError: '',
    statusCode: 0,
  });

  const setDataUpdateStorage = async (params: any) => {
    saveStorege('@mais/delivery/user/update', params);

    setData((field) => {
      return {
        ...field,
        user: params,
      };
    });
  };

  const setEmailStorage = async (email: any) => {
    saveStorege('@mais/delivery/user/update', email);

    const userData = await api.apiMaisdelivery.auth.getDataUser<iResult>({
      nr_operacao: 44,
      dsEmail: email.dsEmail,
    });

    if (userData.data.retorno === 'OK') {
      setData((field) => {
        return {
          ...field,
          typeValidation: 'email',
          codeValidation: userData.data.codigo,
          return: userData.data.retorno,
          msgError: '',
        };
      });
      return;
    }
    setData({
      msgError: userData.data.mensagem,
    });
  };

  const setPhoneStorage = async (phone: any, type: string) => {
    const resultCity = getStorege('@mais/delivery/dataStateCity');
    const result = getStorege('@mais/delivery/user/update');

    result.typeMsgPhone = type;

    saveStorege('@mais/delivery/user/update', result);

    let userData: any;

    if (type === 'WhatsApp') {
      userData = await api.apiMaisdelivery.auth.getDataUser<iResult>({
        nr_operacao: 43,
        dsCidade: resultCity.dsCidade,
        nrDdd: phone.nrDDD,
        nrTelefone: phone.nrTelefone,
      });
    }

    if (type === 'SMS') {
      userData = await api.apiMaisdelivery.auth.getDataUser<iResult>({
        nr_operacao: 38,
        dsCidade: resultCity.dsCidade,
        nrDdd: phone.nrDDD,
        nrTelefone: phone.nrTelefone,
      });
    }
    if (userData.data.retorno === 'OK') {
      setData((field) => {
        return {
          ...field,
          typeValidation: 'phone',
          codeValidation: userData.data.codigo,
          return: userData.data.retorno,
          msgError: '',
        };
      });
      return;
    }
    setData({
      msgError: userData.data.mensagem,
    });
  };

  const setValidation = async (type: string) => {
    const result = getStorege('@mais/delivery/user/update');
    if (type === 'email') {
      result.emailValid = 'true';
    } else {
      result.phoneValid = 'true';
    }
    saveStorege('@mais/delivery/user/update', result);
  };

  const cleanData = async () => {
    setData((field) => {
      return {
        ...field,
        codeValidation: '',
        return: '',
        msgError: '',
      };
    });
  };

  const userUpdate = async (formParams: any) => {
    createloading(true);
    try {
      try {
        const result = await api.apiMaisdelivery.auth.updateDataUser<iResult>({
          nr_operacao: 16,
          ...formParams,
        });

        createloading(false);
        if (result.data.retorno === 'OK') {
          getDataUser(formParams.idUsuario);
          setData({
            msgError: 'Dados atualizado com sucesso',
          });
        } else {
          setData({
            msgError: result.data.mensagem,
          });
        }
      } catch (error) {
        setData({
          msgError: 'Ocorreu um erro ao atualizar seus dados, tente novamente',
        });
      }
      createloading(true);
    } catch (error: any) {
      createloading(true);
      if (error?.response?.data?.message) {
        setData({
          msgError: error.response.data.message,
        });
        return;
      }
      setData({
        msgError: 'Ocorreu algum erro, tente novamente mais tarde.',
      });
    }
  };

  return (
    <SignInContext.Provider
      value={{
        data,
        setDataUpdateStorage,
        setEmailStorage,
        setValidation,
        cleanData,
        setPhoneStorage,
        userUpdate,
      }}
    >
      {children}
    </SignInContext.Provider>
  );
};

export const useUserUpdateContext: any = () => {
  return useContext(SignInContext);
};
